// extracted by mini-css-extract-plugin
export default {"feedForwardText":"index_feedForwardText_Uzjf3","articleForwardText":"index_articleForwardText_FZfcO"};